import {BaseModel} from "../../../infrastructure/models/base-model";

export class FilterBarModuleSortModel extends BaseModel {
  index: Number;
  name: String;

  constructor(model) {
    super()

    this.index = model.index;
    this.name = model.name;
  }
}
